import React, { Component } from "react";
import { push } from "../Services/Analytics"

import "./Header.scss"

class Header extends Component {
  constructor() {
    super()
    this.state = {
      isShareActive: false,
      isSlided: false
    }
    this.shareBTN = this.shareBTN.bind(this);
  }
  componentWillMount() {
    window.addEventListener("scroll", () => {
      this.setState({
        isSlided: (window.scrollY > 0.10 * window.screen.width ? true : false)
      })
    });
  }
  shareBTN(action) {
    var shareText = "איך אתם אוהבים את הבוקר שלכם?";;
    var url = "https://z.ynet.co.il/mShort/commerce/2018/coffeequiz/";
    switch (action) {
      default:
      case "facebook":
        push("Share_Facebook", url);
        window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent(url) + "&redirect_uri=" + encodeURIComponent(url), "_blank");
        break;
      case "twitter":
        push("Share_Twitter", url);
        window.open("https://twitter.com/intent/tweet?text=" + encodeURIComponent(window.document.title) + "&url=" + encodeURIComponent(url), "_blank");
        break;
      case "whatsapp":
        push("Share_WhatsApp", url);
        window.open("whatsapp://send?text=" + encodeURIComponent(shareText + " >> " + url), "_parent");
        break;
      case "negishut":
        push("Accessibility", "Open_Accessibility_Clicked");
        var elem = window.document.getElementById('INDmenu-btn');
        var event = new Event('click');
        elem.dispatchEvent(event);
        break;
      case "sharer":
        this.setState({
          isShareActive: !this.state.isShareActive
        })
        break;
    }
  }
  render() {
    return (
      <header>
        <div id="header" className={`${(this.state.isSlided ? "active" : "")}`}>
          <div className="padding">
            <div className="container">
              <div className="publisher">
                <a href="https://www.ynet.co.il/" title="ynet" target="_blank">
                  <div className="logo"></div>
                </a>
              </div>
              <div className="utils">
                <div className={`share${(this.state.isShareActive ? " active " : "")}`}>
                  <div onClick={() => { this.shareBTN("twitter") }} className="twitter"></div>
                  <div onClick={() => { this.shareBTN("whatsapp") }} className="whatsapp"></div>
                  <div onClick={() => { this.shareBTN("facebook") }} className="facebook"></div>
                  <div onClick={() => { this.shareBTN("sharer") }} className="sharer"></div>
                  <div onClick={() => { this.shareBTN("negishut") }} className="negishut"></div>
                </div>
                <div className="sponser">
                  <div className="pblogo"></div>
                  <a href="https://www.nespresso.com/il/he/" title="" target="_blank"><div className="sponslogo"></div></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="virtualHeader" className={`${(window.location.href.indexOf("whoami") > -1 ? "lead" : "")}`}></div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header/Header.js